import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { MerchantsController } from './merchants.controller';
import { PermissionsController } from './permissions.controller';
import { RolesController } from './roles.controller';
import { PlatformService } from './platform.service';

@Module({
  imports: [AuthModule, NotificationsModule],
  controllers: [MerchantsController, PermissionsController, RolesController],
  providers: [PrismaService, PlatformService],
  exports: [PlatformService],
})
export class PlatformModule {}
